import React, {useRef, useEffect} from "react";
import { Layout, Button, Card, Checkbox, Form } from "element-react";
import { useHistory } from "react-router-dom";
import WizardLeftMenu from "./wizardLeftMenu";

export default function WizardNgStepMinus1({ handleNextStep, step, form, rules, formInputs, setFormInputs }) {
  const history = useHistory();
  const [counter, setCounter] = React.useState(0);
  const [condition, setCondition] = React.useState([
    { id: 1, checked: false, label: "I represent a legally registered business" },
    { id: 2, checked: false, label: "I manufacture/produce/distribute goods/products/components" },
    { id: 3, checked: false, label: "I understand my information must be submitted in english" },
  ]);
  const refCb1 = useRef();
  const refCb2 = useRef();
  const refCb3 = useRef();

  const goHome = () => {
    history.push("/dashboard");
  };

  
  useEffect(() => {
    if (formInputs.condition1 && formInputs.condition2 && formInputs.condition3) {
      clearAllErrors();
    }else{
      if(counter > 0)
        localHandleNextStep();
      else
        setCounter(counter + 1);
    }
    
  }
  , [formInputs.condition1, formInputs.condition2, formInputs.condition3]);

  const clearAllErrors = () => {
      refCb1.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
      refCb1.current.children[0].children[0].children[0].style.color = '#606266';
      refCb1.current.children[0].children[0].children[0].innerHTML = ' ';

      refCb2.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
      refCb2.current.children[0].children[0].children[0].style.color = '#606266';
      refCb2.current.children[0].children[0].children[0].innerHTML = ' ';

      refCb3.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
      refCb3.current.children[0].children[0].children[0].style.color = '#606266';
      refCb3.current.children[0].children[0].children[0].innerHTML = ' ';
  }

  const localHandleNextStep = () => {
    form.current.validate((valid) => {
      console.log('valid', valid);
      if (formInputs.condition1 && formInputs.condition2 && formInputs.condition3) {
        handleNextStep();
      } else {
        console.log('error submit!!');
        //set error message to checkboxes
        if(!formInputs.condition1) {
          console.dir(refCb1.current);
          //ref is to the div that contains the checkbox
          refCb1.current.children[0].children[0].children[0].style.border = '1px solid red';
          //add error message
          refCb1.current.children[0].children[0].children[0].innerHTML = `
            <div style="color: red; position: absolute" > <br/><br/>Please check this box<div>
            `
        }else{
          refCb1.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
          refCb1.current.children[0].children[0].children[0].style.color = '#606266';
          refCb1.current.children[0].children[0].children[0].innerHTML = ' ';
          
        }
        if(!formInputs.condition2) {
          refCb2.current.children[0].children[0].children[0].style.border = '1px solid red';
          //add error message
          refCb2.current.children[0].children[0].children[0].innerHTML = `
            <div style="color: red; position: absolute" > <br/><br/>Please check this box<div>
            `
        }else{
          refCb2.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
          refCb2.current.children[0].children[0].children[0].style.color = '#606266';
          refCb2.current.children[0].children[0].children[0].innerHTML = ' ';
        }
        if(!formInputs.condition3) {
          refCb3.current.children[0].children[0].children[0].style.border = '1px solid red';
          //add error message
          refCb3.current.children[0].children[0].children[0].innerHTML = `
            <div style="color: red; position: absolute" > <br/><br/>Please check this box<div>
            `
        }else{
          refCb3.current.children[0].children[0].children[0].style.border = '1px solid #dcdfe6';
          refCb3.current.children[0].children[0].children[0].style.color = '#606266';
          refCb3.current.children[0].children[0].children[0].innerHTML = ' ';
        }
        return false;
      }
    });
  };

  return (
    <Layout.Row>
      <WizardLeftMenu step={step}/>
      <Layout.Col xs="24" sm="24" md="20" lg="20">
        <Card className="box-card create-store-box">
          <Layout.Row>
            <div className="create-store-title">
              <h1>Create your Company Microsite and start selling</h1>
              <p>Completion time: 10 minutes</p>
            </div>
            <p>
              Your Microsite is your presentation card in Bainub.<br />
              Build trust with your potential trade partners by creating a
              professional Microsite showing relevant information about your
              company.
            </p>
            <h5>You will need:</h5>
            <ul>
              <li>Your business description</li>
              <li>Two pictures of your company</li>
            </ul>
            <h5>Please consider:</h5>
            <ul>
              <li>You must own/represent the Business Name.</li>
              <li>Upload your information in english.</li>
              <li>
                You will be able to edit/optimize your Business Microsite after
                completion.
              </li>
            </ul>
          </Layout.Row>
          <Layout.Row>
            <h5>Take a moment to read and agree to the following:</h5>
            <Form ref={form} model={formInputs} className="en-US mt-2" rules={rules} label-position="top">
            {condition.map((item, index) => (
              <div key={item.id} style={{ marginBottom: '15px' }}>
                <Form.Item prop={'condition'+item.id}>
                  <div className="error-message" ref={item.id === 1 ? refCb1 : item.id === 2 ? refCb2 : refCb3}>
                  <Checkbox
                    checked={formInputs['condition'+item.id]}
                    name={'condition'+item.id}
                    style={{ borderColor: 'red' }}
                    onChange={(v) =>{
                      setFormInputs({...formInputs, ['condition'+item.id]: v }); console.log('Switch :: ' + v);
                    }}
                  >
                    {item.label}
                  </Checkbox>
                  </div>
                </Form.Item>
              </div>
            ))}
            </Form>
          </Layout.Row>
          <Layout.Row className="mt-5">
            <Button type="secondary" onClick={goHome}>
              Go back
            </Button>
            <Button type="primary" onClick={localHandleNextStep}>
              Let's Go!
            </Button>
          </Layout.Row>
        </Card>
      </Layout.Col>
    </Layout.Row>
  );
}